<script setup lang="ts">
/**
 * Use the current parameters.
 */
const { config } = useParams()

/**
 * Whether the previous view was a country.
 */
const fromCountryView = ref(Boolean(config.country))

/**
 * Set the previous view type.
 */
function onAfterEnter() {
    fromCountryView.value = Boolean(config.country)
}
</script>

<template>
    <Transition
        enter-active-class="transform transition ease-in-out duration-500"
        :enter-from-class="
            config.country ? 'translate-x-full' : 'translate-y-full'
        "
        :enter-to-class="config.country ? 'translate-x-0' : 'translate-y-0'"
        leave-active-class="transform transition ease-in-out duration-500"
        :leave-from-class="fromCountryView ? 'translate-x-0' : 'translate-y-0'"
        :leave-to-class="
            fromCountryView ? 'translate-x-full' : 'translate-y-full'
        "
        @after-enter="onAfterEnter"
    >
        <slot />
    </Transition>
</template>